import React from 'react';
import moment from "moment";
import { ContratoEntidade } from '../../../../entidades';
import { Box, Col, Row, StaticField } from '@intech/web-ui';

interface ItemProps {
  detalhe: ContratoEntidade;
  pensionista: boolean;
}

export const Detalhe: React.FC<ItemProps> = ({
  detalhe,
  pensionista
}) => {

  function CorrigirData(data: Date | undefined) {
    if (data === undefined)
      return "";
    const Data = moment(data, "DD/MM/yyyy");
    if (Data.isValid())
      return Data.format("DD/MM/yyyy")
    return "";
  }

  return (
    <Box title={"Dados do Empréstimo"}>

      <Row>
        <Col>
          <StaticField
            inline
            labelPosition={"up"}
            title={"Contrato"}
            value={`${detalhe.NUM_CONTRATO}/${detalhe.ANO_CONTRATO}`}
          />
        </Col>

        <Col>
          <StaticField
            inline
            labelPosition={"up"}
            value={pensionista ? detalhe.NOME_PENSIONISTA : detalhe.NOME_PARTICIPANTE}
            title={"Nome"}
          />
        </Col>
      </Row>

      <Row>
        <Col>
          <StaticField
            inline
            labelPosition={"up"}
            value={pensionista ? detalhe.CPF_PENSIONISTA : detalhe.CPF_PARTICIPANTE}
            title={"CPF"}
          />
        </Col>

        <Col>
          <StaticField
            inline
            labelPosition={"up"}
            value={detalhe.DS_PLANO}
            title={"Plano"}
          />
        </Col>
      </Row>

      <Row>
        <Col>
          <StaticField
            inline
            labelPosition={"up"}
            value={detalhe.DS_SITUACAO}
            title={"Situação"}
          />
        </Col>

        <Col>
          <StaticField
            inline
            labelPosition={"up"}
            value={detalhe.DS_MODAL}
            title={"Modalidade"}
          />
        </Col>
      </Row>

      <Row>
        <Col>
          <StaticField
            inline
            labelPosition={"up"}
            value={detalhe.DS_NATUR}
            title={"Natureza"}
          />
        </Col>

        <Col>
          <StaticField
            inline
            labelPosition={"up"}
            value={detalhe.PRAZO}
            title={"Prazo"}
          />
        </Col>
      </Row>

      <Row>
        <Col>
          <StaticField
            inline
            labelPosition={"up"}
            value={CorrigirData(detalhe.DT_SOLICITACAO)}
            title={"Solicitado em"}
          />
        </Col>

        <Col>
          <StaticField
            inline
            labelPosition={"up"}
            value={CorrigirData(detalhe.DT_CREDITO)}
            title={"Data de Crédito"}
          />
        </Col>
      </Row>

      <Row>
        <Col>
          <StaticField
            inline
            labelPosition={"up"}
            value={detalhe.VL_SOLICITADO!}
            title={"Valor Solicitado"}
            type={"money"}
          />
        </Col>

        <Col>
          <StaticField
            inline
            labelPosition={"up"}
            value={detalhe.VL_IOF!}
            title={"IOF"}
            type={"money"}
          />
        </Col>
      </Row>

      <Row>
        <Col>
          <StaticField
            inline
            labelPosition={"up"}
            value={detalhe.VL_TX_ADM!}
            title={"Taxa ADM"}
            type={"money"}
          />
        </Col>

        <Col>
          <StaticField
            inline
            labelPosition={"up"}
            value={detalhe.VL_REFORMADO!}
            title={"Valor Reformado"}
            type={"money"}
          />
        </Col>
      </Row>

      <Row>
        <Col>
          <StaticField
            inline
            labelPosition={"up"}
            value={detalhe.VL_LIQUIDO!}
            title={"Valor Líquido"}
            type={"money"}
          />
        </Col>

        <Col>
          <StaticField
            inline
            labelPosition={"up"}
            value={`${detalhe.NUM_BANCO}/${detalhe.NUM_AGENCIA}/${detalhe.NUM_CONTA}`}
            title={"Dados Bancários"}
          />
        </Col>
      </Row>
    </Box>
  );
}